<template>
  <a-layout class="layout">
    <a-layout-sider :trigger="null" collapsible v-model="collapsed">
      <!-- <div class="logo">罗高仕</div> -->
      <router-link to="/" class="logo" tag="div">罗高仕</router-link>
      <side-menu></side-menu>
    </a-layout-sider>
    <a-layout class="body">
      <a-layout-header
        style="background: #fff; padding: 0 24px"
        class="header"
        :style="{ left: collapsed ? '80px' : '200px' }"
      >
        <a-row type="flex" justify="space-between" align="middle">
          <a-col>
            <a-icon
              class="trigger"
              :type="collapsed ? 'menu-unfold' : 'menu-fold'"
              @click="collapsed = !collapsed"
            />
          </a-col>
          <a-col>
            <a-row type="flex" align="middle" :gutter="30">
              <!-- <a-col>
                <a-button v-if = "is_gray == '1'" type="primary" @click="goNewAddPost">(新)发布职位</a-button>
              </a-col> -->
              <!-- <a-col>
                <a-button type="primary" @click="goAi">智能对话Bot Beta</a-button>
              </a-col> -->
              <a-col>
                <!--<router-link to="/post-edit">-->
                <a-button type="primary" @click="addPost">发布职位</a-button>
                <!--</router-link>-->
              </a-col>
              <a-col>
                <a-button type="primary" @click="addClient">添加客户</a-button>
              </a-col>
              <a-col>
                <router-link to="/message">
                  <a-badge :overflowCount="10" :count="$store.state.message">
                    <a-icon type="bell" style="font-size: 20px"></a-icon>
                  </a-badge>
                </router-link>
              </a-col>
              <a-col>
                <a-button type="link" icon="user">{{ user.name }}</a-button>
              </a-col>
              <a-col>
                <a-button type="link" icon="logout" @click="doLogout"
                  >安全退出</a-button
                >
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-layout-header>
      <div :class="$route.fullPath == '/system/aidemo'?'inner1':'inner'">
        <a-layout-content class="content">
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>
          <transition
            appear-active-class="animated zoomIn fast"
            name="router"
            enter-active-class="animated fadeIn fast"
          >
            <router-view v-if="!$route.meta.keepAlive"></router-view>
          </transition>
        </a-layout-content>
        <a-layout-footer :style="{ textAlign: 'center', fontSize: '13px' }"
          >COPYRIGHT © 2019 罗高仕・ALL RIGHTS RESERVED.
          京ICP备16007615号-2</a-layout-footer
        >
      </div>
    </a-layout>
  </a-layout>
</template>
<script>
import SideMenu from "@/components/side-menu/menu";
import { mapActions, mapMutations, mapState } from "vuex";
import Api from "@/api";
import store from "@/shared/store";
import { bootstrap, getOrderStatus } from "@/shared/utils/bootstrap";
import avatarImg from "@/assets/avatar.png";

export default {
  name: "admin",
  data() {
    return {
      avatarImg,
      collapsed: false,
      is_gray: "",
      // watchFlag: ""
    };
  },
  computed: {
    ...mapState(["user"]),
    ...mapState("im", ["conversationList", "c2cConversationList", "currentConversation"]),
  },
  async created() {
    this.initListener();
    let res = await Api.im.getUserSig();
    // await this.$tim.login({
    //   userID: String(userId),
    //   userSig,
    // });
    console.log(res)
    let promise = this.$tim.login({userID: res.userId.toString(), userSig: res.userSig});
    promise.then((imResponse)=> {
      console.log(imResponse.data); // 登录成功
      if (imResponse.data.repeatLogin === true) {
        // 标识账号已登录，本次登录操作为重复登录。v2.5.1 起支持
        console.log(imResponse.data.errorInfo);
      }
    }).catch(function(imError) {
      console.warn('login error:', imError); // 登录失败的相关信息
    });
    this.is_gray = localStorage.getItem("is_gray");
  },
  components: { SideMenu },
  methods: {
    ...mapMutations(["setOrderStatus"]),
    ...mapActions(["logout"]),
    ...mapMutations("im", [
      "pushCurrentMessageList",
      "updateConversationList",
      "updateImState",
    ]),
    ...mapActions("im", ["updateGroupList"]),
    async doLogout() {
      try {
        await this.logout();
        this.$router.push("/login");
      } catch (e) {
        console.log(e);
      }
    },
    addClient() {
      this.$store.commit("addCompany", true);
      if (this.$route.fullPath !== "/client-manage") {
        this.$router.push({
          path: "/client-manage",
        });
      }
    },
    addPost() {
      this.$router.push({
        path: "/post-edit",
        query: {
          type: "edit",
        },
      });
    },
    goNewAddPost(){
      this.$router.push({
        path: "/post-new",
        query: {
          type: "edit",
        },
      });
    },
    goAi(){
      if (this.$route.fullPath !== "/system/aidemo") {
        this.$router.push({
          path: "/system/aidemo",
        });
      }
      // this.$router.push({
      //     path: "system/aidemo",
      //   });
    },
    initListener() {
      // SDK NOT READT
      this.$tim.on(this.$TIM.EVENT.SDK_NOT_READY, (event) => {
        console.log("IM 登陆失败", event);
      });
      // 被踢出
      // this.$tim.on(this.$TIM.EVENT.KICKED_OUT, () => {
      //   this.$store.commit("showMessage", {
      //     message: "被踢出，请重新登录。",
      //     type: "error"
      //   });
      //   this.$store.commit("toggleIsLogin", false);
      //   this.$store.commit("reset");
      // });

      // 登录成功后会触发 SDK_READY 事件，该事件触发后，可正常使用 SDK 接口
      this.$tim.on(this.$TIM.EVENT.SDK_READY, this.onReadyStateUpdate, this);
      // SDK内部出错
      this.$tim.on(this.$TIM.EVENT.ERROR, this.onError);

      // 收到新消息
      this.$tim.on(this.$TIM.EVENT.MESSAGE_RECEIVED, (event) => {
        this.pushCurrentMessageList(event.data);
        console.log("新消息", event.data);
        let message = event.data[0];
        let conversation = null;
        if (
          message.conversationType === "GROUP" &&
          message.type !== this.$TIM.TYPES.MSG_GRP_TIP
        ) {
          this.updateGroupList();
          // 只从已加载的会话列表取对象做通知，不能 checkoutConversation——
          // 它内部 setMessageRead 会把该群标为已读，且多端已读同步会清掉所有端的未读
          const conv = this.conversationList.find(
            (item) => item.conversationID === message.conversationID
          );
          if (conv) {
            this.sendNotification(conv, message, "groupMessage");
          }
        } else {
          conversation = this.c2cConversationList.filter((item) => {
            return item.conversationID === message.conversationID;
          });
          this.sendNotification(conversation[0], message, "message");
        }
      });
      // 会话列表更新
      this.$tim.on(this.$TIM.EVENT.CONVERSATION_LIST_UPDATED, (event) => {
        // this.conversationList = event.data;
        this.updateConversationList(event.data);
      });
      // 群组列表更新
      this.$tim.on(this.$TIM.EVENT.GROUP_LIST_UPDATED, (event) => {
        // this.groupList = event.data;
        // console.log("群组列表更新", event);
        // this.updateGroupList(event.data);
      });
      // 收到新的群系统通知
      this.$tim.on(this.$TIM.EVENT.GROUP_SYSTEM_NOTICE_RECEIVED, (event) => {
        console.log("群系统消息", event.data);
        // this.sendNotification(conversation[0], message, 'message');
        // const isKickedout = event.data.type === 4;
        // const isCurrentConversation =
        //   `GROUP${event.data.message.payload.groupProfile.groupID}` ===
        //   this.currentConversation.conversationID;
        // 在当前会话被踢，需reset当前会话
        // if (isKickedout && isCurrentConversation) {
        //   this.$store.commit("resetCurrentConversation");
        // }
        // Notification({
        //   title: "新系统通知",
        //   message: translateGroupSystemNotice(event.data.message),
        //   duration: 3000,
        //   onClick: () => {
        //     const SystemConversationID = "@TIM#SYSTEM";
        //     this.$store.dispatch("checkoutConversation", SystemConversationID);
        //   }
        // });
      });
    },
    sendNotification(conversation, message, notificationType) {
      console.log(conversation, "conversation");
      let userProfile = conversation.userProfile || conversation.groupProfile;
      this.$notification.open({
        key: notificationType,
        message:
          notificationType === "message"
            ? "您收到一条新消息"
            : "您收到一条群消息",
        description: (h) => {
          return (
            <div class="notification-content">
              <img class="notification-avatar" src={userProfile.avatar} />
              <div>
                <div class="nick-name">
                  {userProfile.nick || userProfile.name}
                </div>
                <div>{conversation.lastMessage.messageForShow}</div>
              </div>
            </div>
          );
        },
        placement: "bottomRight",
        duration: 3,
        // onClick: () => {
        //   // const SystemConversationID = "@TIM#SYSTEM";
        //   this.$router.push('/im');
        //   this.$store.dispatch("im/checkoutConversation", message.conversationID);
        // }
      });
    },
    onReadyStateUpdate({ name }) {
      const isSDKReady = name === this.$TIM.EVENT.SDK_READY ? true : false;

      console.log("IM 准备就绪");
      this.updateImState(isSDKReady);
      this.updateGroupList();
      // 订单页群聊未读数依赖 im.conversationList；SDK 就绪后主动拉一次初始列表，
      // 否则列表为空、未读数恒为 0（后续增量靠 CONVERSATION_LIST_UPDATED）
      this.$tim.getConversationList().then((res) => {
        this.updateConversationList(res.data.conversationList);
      });
    },
    onError({ data }) {
      if (data.message !== "Network Error") {
        this.$message.error(data.message);
      }
    },
  },
  async beforeRouteEnter(to, from, next) {
    let flag = await bootstrap(to);
    next((vm) => {
      if (!flag) {
        vm.$router.push("/message");
      }
    });
  },
  async beforeRouteUpdate(to, from, next) {
    next();
  },
  beforeDestroy() {
    // clearInterval(this.watchFlag);
  },
};
</script>

<style lang="scss">
.layout.ant-layout-has-sider {
  .ant-layout-sider {
    height: 100vh;
    overflow-y: auto;
  }
  .ant-layout-sider-collapsed {
    .logo {
      font-size: 16px;
    }
  }
  .logo {
    color: #fff;
    text-align: center;
    line-height: 64px;
    font-size: 20px;
    font-weight: bold;
  }
  .trigger {
    font-size: 18px;
    cursor: pointer;
    transition: color 0.3s;
    &:hover {
      color: #1890ff;
    }
  }
}
.body.ant-layout {
  padding-top: 64px;
  height: 100vh;
  justify-content: space-between;
  .header {
    position: fixed;
    z-index: 500;
    top: 0;
    right: 0;
    transition: 0.2s ease;
  }
  .inner {
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    & > .content {
      position: relative;
      min-height: auto;
      margin: 24px 16px 0;
      padding: 24px;
      background: #fff;
    }
  }
  .inner1{
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    & > .content {
      position: relative;
      min-height: auto;
      margin: 24px 16px 0;
     // padding: 24px;
      background: #fff;
    }
  }
}
.notification-content {
  display: flex;
  align-items: center;
  .nick-name {
    margin-bottom: 10px;
    font-weight: 600;
  }
}
.notification-avatar {
  display: inline-block;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-right: 10px;
}
</style>
